import { useEffect, useRef, useState } from "react";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core";
import { useNavigate, useLocation } from "react-router-dom";
import UserInfo from "../../context/UserAccessContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { useQuery } from "react-query";
import { PostmortemServices } from "../../services/postmortemServices";
import { convertEpochToDateFormat } from "../../Utils/convertEpochToDateFormat";
import { formatAssignedToDisplay } from "../../Utils/formatAssignedToDisplay";
import React from "react";
import successNotification from "../../Components/Notification/successNotification";
import errorNotification from "../../Components/Notification/errorNotification";
import uploadInitiatedNotification from "../../Components/Notification/uploadInitiatedNotification";
import { postmortemApiEndpoint } from "../../config";
import { McSelect } from "@maersk-global/mds-react-wrapper/components-core/mc-select";
import { McOption } from "@maersk-global/mds-react-wrapper/components-core/mc-option";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import { McTextarea } from "@maersk-global/mds-react-wrapper";
import ArtifactsPanel from "../../Components/ArtifactsPanel/ArtifactsPanel";
import RowActionsMenu from "../../Components/PostmortemsTable/RowActionsMenu";
import { useMsal } from "@azure/msal-react";

export const UseMetaData = (currentLocation) => {
  const [metaData, setMetaData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [incidentIdToSearch, setIncidentIdToSearch] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const { fetchPaginatedPostMortemData } = PostmortemServices();
  const { fetchEnhancement, startPause, stopPause } = PostmortemServices();

  const [editorIsOpen, setEditorIsOpen] = useState(false);
  
  const { accounts } = useMsal();
  const accountId = accounts[0]?.homeAccountId;

  const {
    userIsAdmin,
    userIsMttsAdmin,
    userAccessData,
    userAccessLoading,
    userAccessError,
    setFetchAgain,
    userIsSreUser,
    userIsAMimMember,
    userIsApmtMember,
  } = UserInfo();

  const [currentEditingPostmortemId, setCurrentEdittingPostmortemId] =
    useState("");

  const divRef = useRef(null);
  const handleEditorOpen = (postId) => {
    setEditorIsOpen(true);
    setCurrentEdittingPostmortemId(postId);
  };
  const [pg, setPg] = useState(1);
  const [pgSize, setPgSize] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const [filters, setFilters] = useState({ priority: [], status: [], ci: "", causedByCi: "", portfolio: "", incidentId: location?.state?.searchIncidentId || "" });
  // Global navbar search re-navigates here with a new term, which useState's initial value would ignore.
  useEffect(() => {
    if (location?.state?.searchIncidentId !== undefined) {
      setFilters((f) => ({ ...f, incidentId: location.state.searchIncidentId }));
      setPg(1);
    }
  }, [location?.state?.searchIncidentId]);
  const [sorting, setSorting] = useState("");
  const [sortDirection, setSortDirection] = useState("DESC");
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState([]);

  const { postPostMortemData } = PostmortemServices();
  // Removed unnecessary setFetchAgain toggle - was causing duplicate API calls

  const edit = (
    incidentID,
    problemID,
    priority,
    createdOn,
    cmdb_ci,
    state,
    assigned_to,
    customID,
    currObj
  ) => {
    navigate(`/editpostmortem?postmortemID=${customID}&page_type=edit`, {
      // state: {
      //   incidentID: incidentID,
      //   problemID: problemID,
      //   priority: priority,
      //   createdOn: createdOn,
      //   cmdb_ci: cmdb_ci,
      //   state: state,
      //   assigned_to: assigned_to,
      //   customID: customID,
      //   allData: currObj,
      // },
    });
  };

  const [comments, setComments] = useState({});
  const [loadingStates, setLoadingStates] = useState({});
  const [currentChangingBu, setCurrentChangingBu] = useState({});
  const commentsRef = useRef();
  const loadingStatesRef = useRef();
  const artifactsPanelRefs = useRef({});
  commentsRef.current = comments;
  loadingStatesRef.current = loadingStates;

  const report = (customID, incidentID) => {
    const incidentIDParam = incidentID ? encodeURIComponent(incidentID) : "";
    navigate(
      `/report?incidentID=${incidentIDParam}&postmortemID=${encodeURIComponent(customID)}&page_type=report`
    );
  };

  const handleSorting = (sortOn) => {
    const createdOnSort = sortOn?.find((sort) => sort.id === "createdOn");
    if (!createdOnSort) return;
    setPg(1);
    setSorting(sortOn);
    setSortDirection(createdOnSort.desc ? "DESC" : "ASC");
  };

  const handleClearSearchText = () => {
    setIncidentIdToSearch("");
  };
  const handleSearchIdText = (e) => {
    setIncidentIdToSearch(e.target.value);
  };

  const tableDataRef = useRef(tableData);

  useEffect(() => {
    tableDataRef.current = tableData;
  }, [tableData]);

  const handleBusinessUnitChange = (value, pmtID, data) => {
    setSelectedBusinessUnit((currBusinessUnit) => [
      ...currBusinessUnit,
      { pmtID: pmtID, businessUnit: value },
    ]);
    setCurrentChangingBu({ pmtID: pmtID, value: value });
    saveBusinessUnit(value, pmtID, data);
  };

  useEffect(() => {
    if (currentChangingBu) {
      let currentTableData = tableDataRef.current.map((incident) => {
        if (incident.customID === currentChangingBu.pmtID) {
          // Create a new object with the updated owning_unit
          return {
            ...incident,
            owning_unit: {
              ...incident.owning_unit,
              props: {
                ...incident.owning_unit.props,
                value: currentChangingBu.value,
              },
            },
          };
        } else {
          return incident;
        }
      });

      setTableData(() => [...currentTableData]);
    }
  }, [currentChangingBu]);

  const saveComment = async (incidentID, postmortems) => {
    const makeRequest = async () => {
      let postmortemData = postmortems.find(
        (postmortem) => postmortem.incidentID === incidentID
      );

      postmortemData["pmNotCompleted"] = commentsRef.current[incidentID];
      try {
        const apiResponse = await postPostMortemData(
          apiEndpoint,
          incidentID,
          postmortemData
        );

        if (apiResponse.status === 200 || apiResponse.status === 201) {
          successNotification("Comment saved successfully");
        } else {
          throw new Error("Unknown error");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          sessionStorage.clear();
        }

        console.log(error);
        throw error;
      }
    };

    try {
      uploadInitiatedNotification();
      setLoadingStates(() => {
        return {
          ...loadingStatesRef.current,
          [incidentID]: true,
        };
      });
      await makeRequest();
    } catch (error) {
      // toast.done("upload-progress");
      errorNotification("Error in saving comment");
      if (error.response && error.response.status === 500) {
        // setStep(step);
      } else {
        console.log("Unknown error");
        // setStep(step);
        console.error(error);
      }
      throw error;
    } finally {
      setLoadingStates(() => {
        return {
          ...loadingStatesRef.current,
          [incidentID]: false,
        };
      });
    }
  };

  const saveBusinessUnit = async (businessUnit, incidentID, postmortem) => {
    postmortem["owningBusinessUnitUser"] = businessUnit;
    // setSelectBussinessUnit(businessUnit);

    try {
      uploadInitiatedNotification();
      const apiResponse = await postPostMortemData(
        apiEndpoint,
        incidentID,
        postmortem
      );

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        successNotification("Business unit saved successfully");
      } else {
        throw new Error("Unknown error");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        errorNotification("Please reload the page");
        sessionStorage.clear();
      }

      console.log(error);
      throw error;
    }
  };

  const getOwningUnit = (postmortem) => {
    let owning_unit = "";
    const foundBusinessUnit = selectedBusinessUnit?.find(
      (unit) => unit.pmtID === postmortem.customID
    );

    let businessUnitValue =
      foundBusinessUnit?.businessUnit || postmortem["owningBusinessUnitUser"];

    // if(postmortem["u_owning_business_unit"].length === 1){
    //   businessUnitValue = postmortem["u_owning_business_unit"][0];
    // }

    if (userIsSreUser) {
      // Safety check: ensure u_owning_business_unit exists and is an array
      const owningUnits = Array.isArray(postmortem["u_owning_business_unit"]) 
        ? postmortem["u_owning_business_unit"] 
        : [];
      
      if (owningUnits.length === 0 && !businessUnitValue) {
        owning_unit = "NA";
      } else {
        owning_unit = (
          <McSelect
            label="Containers"
            hiddenlabel
            width="100"
            placeholder="Select  Unit"
            name="username"
            optionswidth="50"
            value={businessUnitValue}
            optionselected={(e) =>
              handleBusinessUnitChange(
                e?.detail?.value,
                postmortem.incidentID,
                postmortem
              )
            }
            disabled={!userIsAdmin}
          >
            {owningUnits.map((unit, idx) => {
              if (unit) {
                return (
                  <McOption
                    key={unit}
                    style={{
                      fontSize: "8px",
                    }}
                    value={unit}
                  >
                    <p style={{ fontSize: "14px" }}>{unit}</p>
                  </McOption>
                );
              } else {
                return null;
              }
            })}
          </McSelect>
        );
      }
    } else if (postmortem["owningBusinessUnitUser"]) {
      owning_unit = postmortem["owningBusinessUnitUser"];
    } else {
      owning_unit = "NA";
    }
    return owning_unit;
  };

  // (
  //   <a
  //     href={`${snowLink}number=${currObj.incidentID}`}
  //     target="_blank"
  //     rel="noopener noreferrer"
  //     style={{ textDecoration: "none" }}
  //   >
  //     <div style={{ display: "flex" }}>
  //       {currObj.incidentID}
  //       <McIcon
  //         style={{ marginLeft: "5px" }}
  //         size="16"
  //         color="blue"
  //         icon="square-arrow-up-right"
  //       ></McIcon>
  //     </div>
  //   </a>
  // )

  // {
  //   "email": "abdullah.safwi@maersk.com",
  //   "status": "true"
  // },

  const checkAccess = (currObj, owning_unit) => {
    let ifDisabled = false;
    // console.log("OWNING UNITS ", owning_unit)

    // MTTS and app-level SRE/LT admins can edit any postmortem.
    if (userIsMttsAdmin === true || userIsAdmin === true) {
      return false;
    }

    // Owner of the postmortem always has edit access, regardless of Teams
    // membership - matches the ownership check used in the report view.
    const userEmail = (accounts[0]?.username || accounts[0]?.name || "").toLowerCase();
    const assignedTo = currObj.assigned_to;
    const ownerEmail =
      typeof assignedTo === "string"
        ? assignedTo
        : assignedTo?.email || assignedTo?.value || assignedTo?.label || "";
    if (userEmail && ownerEmail && ownerEmail.toLowerCase() === userEmail) {
      return false;
    }

    // if (owning_unit === "APM Terminals") {
    //   if (userIsApmtMember) {
    //     ifDisabled = false;
    //   }
    // } else {
      if (currObj.priority === "3" || currObj.priority === "4") {
        if (userIsAMimMember) {
          ifDisabled = false;
        } else {
          ifDisabled = !userAccessData?.some(
            (data) => data.postMortemId === currObj.customID
          );
        }
      } else {
        ifDisabled = !userAccessData?.some(
          (data) => data.postMortemId === currObj.customID
        );
      }
    // }

    return ifDisabled;
  };

  const generateArrayForTable = (data) => {
    let snowLink = process.env.REACT_APP_SNOW_LINK;

    let requiredArray = data.map((currObj) => {
      let owning_unit = getOwningUnit(currObj);
      let isDisabled = checkAccess(currObj, owning_unit);
      // checkAccess(currObj);
      const computedState = currObj.postMortemIncomplete
        ? "INCOMPLETE"
        : currObj.status
        ? currObj.status
        : currObj.state
        ? currObj.state
        : "NA";
      return {
        // customID: currObj.customID ? currObj.customID : "NA",
        incidentID: currObj.incidentID ? currObj.incidentID : "NA",
        problemID: currObj.problemID ? currObj.problemID : "NA",
        priority: currObj.priority ? currObj.priority : "NA",
        createdOn: currObj.createdOn
          ? convertEpochToDateFormat(currObj.createdOn)
          : "NA",
        cmdb_ci: currObj["cmdb_ci"] ? currObj.cmdb_ci : "NA",
        caused_by_ci:
          currObj.caused_by_ci ||
          currObj.application ||
          currObj.product ||
          "NA",
        state: computedState,
        assigned_to: formatAssignedToDisplay(currObj["assigned_to"]),
        portfolio: currObj.portfolio || currObj.Portfolio || "NA",
        actions: (
          <>
            <RowActionsMenu
              items={[
                {
                  icon: "eye",
                  label: "View Report",
                  onClick: () => report(currObj.customID, currObj.incidentID),
                },
                {
                  icon: "tray-arrow-up",
                  label: "Upload Artifacts",
                  hidden: !userIsAdmin,
                  onClick: () => artifactsPanelRefs.current[currObj.customID]?.open(),
                },
                {
                  icon: "pencil",
                  label: "Edit Postmortem",
                  disabled: isDisabled,
                  disabledTitle: "You do not have access to edit this postmortem",
                  onClick: () =>
                    edit(
                      currObj.incidentID,
                      currObj.problemID,
                      currObj.priority,
                      currObj.createdOn,
                      currObj.cmdb_ci,
                      currObj.state,
                      currObj.assigned_to,
                      currObj.customID,
                      currObj.owningBusinessUnitUser,
                      currObj
                    ),
                },
              ]}
            />
            {userIsAdmin && (
              <ArtifactsPanel
                ref={(node) => { artifactsPanelRefs.current[currObj.customID] = node; }}
                postMortemId={currObj.customID}
                incidentId={currObj.incidentID}
                uploadedBy={accounts[0]?.username || "unknown"}
                hideTrigger
              />
            )}
          </>
        ),
        u_owning_business_unit: currObj["u_owning_business_unit"],
        admincomments: (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <McTextarea
              width={10000}
              name="explanation"
              label=""
              placeholder="Write short explanation"
              rows="2"
              input={(event) => {
                const newComment = event.target.value;
                setComments((prevComments) => {
                  return {
                    ...prevComments,
                    [currObj.incidentID]: newComment,
                  };
                });
              }}
              //If needed
              value={comments[currObj.incidentID] || currObj.pmNotCompleted}
            ></McTextarea>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "4px" }}>
              <McButton
                label="Save"
                appearance="primary"
                variant="filled"
                fit="small"
                click={() => saveComment(currObj.incidentID, data)}
              />
            </div>
          </div>
        ),
      };
      // }
    });

    return requiredArray;
  };

  const apiEndpoint = postmortemApiEndpoint;

  const shouldFetch = !location?.state?.incidentID;
  const fetchPostMortemData = async () => {
    return fetchPaginatedPostMortemData(apiEndpoint, pg, pgSize, { ...filters, sortDirection });
  };

  const getCommentStateData = (data) => {
    return data.reduce((acc, obj) => {
      // Extract specific keys from each object and add them to the accumulator object
      acc[obj.incidentID] = obj.pmNotCompleted; // Add whatever keys you need here
      return acc;
    }, {});
  };
  const {
    data: postMortemData,
    isFetching: dataLoading,
    error: dataError,
    refetch: refetchPostmortems,
  } = useQuery(
    // Keyed by user, not access data: access data loading later must not trigger a second identical fetch.
    ["postMortemDataPaginated", accountId, pg, pgSize, filters, sortDirection],
    fetchPostMortemData,
    {
      onSuccess: (response) => {
        const { data, totalElements } = response;
        if (data) {
          let filteredData = data;
          const { state } = location || {};
          const { allData, incidentID } = state || {};

          if (allData && incidentID) {
            filteredData = filteredData.filter(
              (incident) => incident.incidentID !== incidentID
            );

            filteredData.unshift(allData);
          } else if (incidentID) {
            const index = filteredData.findIndex(
              (incident) => incident.incidentID === incidentID
            );

            // If the object is found
            if (index !== -1) {
              // Extract the object from the array
              const [incident] = filteredData.splice(index, 1);
              // Place the object at the start of the array
              filteredData.unshift(incident);
            }
          }

          let options = generateArrayForTable(filteredData);
          let requiredStateInitialData = getCommentStateData(filteredData);
          setSelectedBusinessUnit(
            filteredData.map((incident) => {
              return {
                pmtID: incident.customID,  // Use customID as pmtID
                businessUnit: incident["owningBusinessUnitUser"],
              };
            })
          );
          setTableData(options);
          setTotalData(totalElements);
          setComments(requiredStateInitialData);
          setLoadingStates(requiredStateInitialData);
        }
      },
      onError: (err) => {
        console.log("ERROR ", err);
        setTableData(null);
      },
      enabled: !!accounts?.[0],
      keepPreviousData: true, // Keep showing old data while fetching new data
      refetchOnMount: 'always', // Always refetch on mount, even if data exists
      refetchOnWindowFocus: false, // Don't refetch on window focus to avoid interrupting file uploads
      staleTime: 0, // Consider data stale immediately so it refetches on mount
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep paginated data in cache
    }
  );

  // Force refetch when returning to this page (e.g., from edit page)
  useEffect(() => {
    // Refetch data when component mounts or when we return to this page
    if (accountId && location.pathname === '/ongoing-postmortems') {
      console.log("Refetching data - returned to ongoing postmortems page");
      refetchPostmortems();
    }
  }, [location.pathname, accountId, refetchPostmortems]);

  return {
    metaData,
    editorIsOpen,
    handleEditorOpen,
    currentEditingPostmortemId,
    divRef,
    dataLoading,
    tableData,
    dataError,
    setPg,
    setPgSize,
    pg,
    pgSize,
    totalData,
    refetchPostmortems,
    filters,
    setFilters,
    handleSorting,
    sorting,
    sortDirection,
    userAccessLoading,
    userAccessError,
    incidentIdToSearch,
    handleClearSearchText,
    handleSearchIdText,
    generateArrayForTable,
    setTableData,
  };
};
